export default __webpack_public_path__ + "static/media/bonalux.851f4b30.png";